import { c as _c } from "react/compiler-runtime";
import { FeatherCheck, FeatherClock, FeatherInfo, FeatherMail, FeatherX } from '@subframe/core';
import { Badge, LogoArbitralis, OutboundStatusIcon } from '@/shared/components/ui';
import { SanitizedHtml } from '@/shared/components/ui/common/SanitizedHtml';
import type { MensagemStatus } from '@/shared/types/mensagemStatus';
import { convertWhatsAppTextToHtml } from '@/shared/utils/whatsapp';
import type { BolhaWhatsappCertificado, ConversaWhatsappCertificado, DestinatarioAcessosPlataforma, DestinatarioMensagemCertificado, MensagemEmailCertificado } from '../../../types/certificadoAcessosTypes';
import { statusEntregaMaisFraco } from '../../../utils/statusEntregaComunicado';
import { CANAL_LABEL, CanalIcone, WhatsappGlyph } from '../documento/CanalIcone';
export function TituloAcessosPlataforma() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[37px] pt-2"><div className="bg-brand-600/5 text-brand-600 flex items-center gap-[10px] rounded-[8px] px-4 py-[10px]"><CanalIcone canal="PLATAFORMA" className="h-[18px] w-[18px] flex-none" /><span className="text-[13px] font-bold tracking-[0.4px] whitespace-nowrap uppercase">Acessos — {CANAL_LABEL.PLATAFORMA}</span></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface TabelaAcessosDestinatarioProps {
  destinatario: DestinatarioAcessosPlataforma;
}
export function TabelaAcessosDestinatario(t0) {
  const $ = _c(11);
  const {
    destinatario
  } = t0;
  const semAcesso = destinatario.eventos.length === 0;
  let t1;
  if ($[0] !== destinatario.destinatarioLabel) {
    t1 = <div className="mb-[10px] border-l-[3px] border-solid border-neutral-200 pl-3"><span className="text-[14px] font-bold text-neutral-800">{destinatario.destinatarioLabel}</span></div>;
    $[0] = destinatario.destinatarioLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid grid-cols-[210px_1.3fr_1.1fr] border-b border-solid border-neutral-200 bg-neutral-100 px-[14px] py-[9px] text-[11px] font-semibold tracking-[0.5px] text-neutral-500 uppercase"><div>Status</div><div>Histórico de logs</div><div>Dispositivo e localização</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== destinatario.eventos || $[4] !== semAcesso) {
    t3 = semAcesso ? <div className="flex items-center justify-center bg-neutral-50 px-4 py-4"><span className="text-[12.5px] text-neutral-500">Nenhum acesso à plataforma registrado até a emissão deste certificado.</span></div> : destinatario.eventos.map((evento, index) => <div key={`${evento.statusLabel}-${index}`} className={`grid grid-cols-[210px_1.3fr_1.1fr] items-center px-[14px] py-[10px] ${index < destinatario.eventos.length - 1 ? "border-b border-solid border-neutral-100" : ""}`}><div className="flex items-center gap-[10px]"><span className={`flex h-[20px] w-[20px] flex-none items-center justify-center rounded-[6px] ${evento.sucesso ? "bg-success-100" : "bg-error-100"}`}>{evento.sucesso ? <FeatherCheck className="text-success-600 h-[13px] w-[13px]" /> : <FeatherX className="text-error-500 h-[12px] w-[12px]" />}</span><span className="text-brand-600 text-[13px] font-medium">{evento.statusLabel}</span></div><div className="text-[12.5px] text-neutral-700">{evento.detalheLabel}</div><div className="flex flex-col gap-[2px] text-[12px] text-neutral-700"><span>{evento.dispositivoLabel ?? "\u2013"}</span>{evento.coordenadasLabel ? <span className="text-neutral-500">{evento.municipioLabel ? `${evento.municipioLabel} · ` : ""}{evento.coordenadasLabel}</span> : null}</div></div>);
    $[3] = destinatario.eventos;
    $[4] = semAcesso;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="overflow-hidden rounded-[8px] border border-solid border-neutral-200">{t2}{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <div className="px-[37px] pb-[24px]">{t1}{t4}</div>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export function ComunicadosVazio() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[37px] pb-6"><div className="flex items-center justify-center rounded-[8px] border border-solid border-neutral-200 bg-neutral-50 px-4 py-4"><span className="text-[12.5px] text-neutral-500">Nenhuma cópia de mensagem de WhatsApp ou e-mail disponível até a emissão deste certificado.</span></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
const TEXTO_COMUNICADOS_PADRAO = 'Cópias completas e autênticas das mensagens, e-mails e notificações trocadas entre as partes, reproduzidas com o visual exato do conteúdo enviado, com todos os destinatários e identificadores de cada envio.';
interface SecaoTextosIntroProps {
  texto?: string;
}
export function SecaoTextosIntro(t0) {
  const $ = _c(2);
  const {
    texto: t1
  } = t0;
  const texto = t1 === undefined ? TEXTO_COMUNICADOS_PADRAO : t1;
  let t2;
  if ($[0] !== texto) {
    t2 = <div className="px-[37px]"><p className="mb-6 text-[13.5px] text-neutral-700">{texto}</p></div>;
    $[0] = texto;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
interface TabelaDestinatariosMensagemProps {
  destinatarios: DestinatarioMensagemCertificado[];
  contatoTitulo: string;
}
function TabelaDestinatariosMensagem(t0) {
  const $ = _c(12);
  const {
    destinatarios,
    contatoTitulo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>Destinatário</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== contatoTitulo) {
    t2 = <div>{contatoTitulo}</div>;
    $[1] = contatoTitulo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>ID da mensagem</div>;
    t4 = <div>Status</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <div className="grid grid-cols-[1.3fr_1.1fr_1.5fr_0.8fr] bg-neutral-100 px-4 py-[9px] text-[10.5px] font-semibold tracking-[0.5px] text-neutral-500 uppercase">{t1}{t2}{t3}{t4}</div>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== destinatarios) {
    t6 = destinatarios.map(_temp);
    $[7] = destinatarios;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="mb-4 overflow-hidden rounded-[6px] border border-solid border-neutral-200">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(destinatario) {
  return <div key={destinatario.chave} className="grid grid-cols-[1.3fr_1.1fr_1.5fr_0.8fr] items-center border-t border-solid border-neutral-200 bg-white px-4 py-[9px]"><div className="pr-2 text-[12px] font-medium text-neutral-800">{destinatario.nome}</div><div className="pr-2 text-[12px] whitespace-nowrap text-neutral-700">{destinatario.contato}</div><div className="pr-2 text-[11.5px] break-all text-neutral-600">{destinatario.idMensagem}</div><div className={`flex items-center gap-[6px] text-[12px] font-medium ${destinatario.sucesso ? "text-success-600" : "text-error-600"}`}><span className={`h-[6px] w-[6px] flex-none rounded-full ${destinatario.sucesso ? "bg-success-600" : "bg-error-600"}`} />{destinatario.statusLabel}</div></div>;
}
interface CabecalhoConversaWhatsappProps {
  conversa: ConversaWhatsappCertificado;
}
export function CabecalhoConversaWhatsapp(t0) {
  const $ = _c(7);
  const {
    conversa
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-brand-600 mb-2 flex items-center gap-[10px]"><WhatsappGlyph className="h-4 w-4" /><span className="text-[12px] font-bold tracking-[0.6px]">WhatsApp</span></div>;
    t2 = <div className="mb-4 h-px bg-neutral-900 opacity-85" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = conversa.contato ? ` · ${conversa.contato}` : "";
  let t5;
  if ($[3] !== conversa.de || $[4] !== conversa.nome || $[5] !== t4) {
    t5 = <div className="px-[37px]">{t1}{t2}<div className="mb-3 text-[12.5px] leading-[1.8] font-bold text-neutral-700">De: {conversa.de}{t3}Para: {conversa.nome}{t4}</div></div>;
    $[3] = conversa.de;
    $[4] = conversa.nome;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
const COLUNAS_EVIDENCIA_CONVERSA = 'grid grid-cols-[1.2fr_0.6fr_1.6fr_0.9fr]';
interface FatiaEvidenciaConversaProps {
  bolha: BolhaWhatsappCertificado;
  primeira: boolean;
  ultima: boolean;
  /** A linha abre uma página no meio da tabela: repete o cabeçalho das colunas. */
  continuacao: boolean;
}

/**
 * Uma linha da tabela de evidência da conversa: o ID de cada mensagem é a prova que o documento
 * existe para registrar, e sai daqui. Uma linha por bloco pelo mesmo motivo da auditoria — uma
 * conversa longa numa tabela atômica passaria da altura útil da folha A4.
 */
export function FatiaEvidenciaConversa(t0) {
  const $ = _c(26);
  const {
    bolha,
    primeira,
    ultima,
    continuacao
  } = t0;
  const abre = primeira || continuacao;
  const t1 = `px-[37px] ${ultima ? "pb-4" : ""}`;
  const t2 = `overflow-hidden border-x border-solid border-neutral-200 ${abre ? "rounded-t-[6px] border-t" : ""} ${ultima ? "rounded-b-[6px] border-b" : ""}`;
  let t3;
  if ($[0] !== abre) {
    t3 = abre ? <div className={`${COLUNAS_EVIDENCIA_CONVERSA} bg-neutral-100 px-4 py-[9px] text-[10.5px] font-semibold tracking-[0.5px] text-neutral-500 uppercase`}><div>Data</div><div>Hora</div><div>ID da mensagem</div><div>Status</div></div> : null;
    $[0] = abre;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== bolha.dataLabel) {
    t4 = <div className="pr-2 text-[12px] text-neutral-700">{bolha.dataLabel}</div>;
    $[2] = bolha.dataLabel;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== bolha.horaLabel) {
    t5 = <div className="pr-2 text-[12px] whitespace-nowrap text-neutral-700">{bolha.horaLabel}</div>;
    $[4] = bolha.horaLabel;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== bolha.idMensagem) {
    t6 = <div className="pr-2 text-[11.5px] break-all text-neutral-600">{bolha.idMensagem}</div>;
    $[6] = bolha.idMensagem;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `flex items-center gap-[6px] text-[12px] font-medium ${bolha.sucesso ? "text-success-600" : "text-error-600"}`;
  const t8 = `h-[6px] w-[6px] flex-none rounded-full ${bolha.sucesso ? "bg-success-600" : "bg-error-600"}`;
  let t9;
  if ($[8] !== t8) {
    t9 = <span className={t8} />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== bolha.statusLabel || $[11] !== t7 || $[12] !== t9) {
    t10 = <div className={t7}>{t9}{bolha.statusLabel}</div>;
    $[10] = bolha.statusLabel;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t11 = <div className={`${COLUNAS_EVIDENCIA_CONVERSA} items-center border-t border-solid border-neutral-200 bg-white px-4 py-[9px]`}>{t4}{t5}{t6}{t10}</div>;
    $[14] = t10;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t2 || $[21] !== t3) {
    t12 = <div className={t2}>{t3}{t11}</div>;
    $[19] = t11;
    $[20] = t2;
    $[21] = t3;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t1 || $[24] !== t12) {
    t13 = <div className={t1}>{t12}</div>;
    $[23] = t1;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
interface BadgeEnvioProps {
  status: MensagemStatus;
}

/**
 * O selo do cabeçalho da réplica afirmava "Enviado" com ✓ verde em qualquer cenário — inclusive
 * com o envio falho, três linhas abaixo da tabela que registra a falha.
 *
 * SENT, DELIVERED e SEEN continuam no selo verde "Enviado" do mock: os três sustentam a
 * afirmação, e nenhum deles é estado novo. Os dois que mudam a aparência — falha e envio em
 * curso — são estados que o mock não tinha (regra #13); o visual deles é dos componentes que o
 * design system já define, e precisa do aval da designer.
 */
function BadgeEnvio(t0) {
  const $ = _c(3);
  const {
    status
  } = t0;
  if (status === "FAILED") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Badge variant="error" icon={<FeatherX />}>Falha no envio</Badge>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (status === "PENDING") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Badge variant="neutral" icon={<FeatherClock />}>Enviando</Badge>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Badge variant="success" icon={<FeatherCheck />}>Enviado</Badge>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
const TEXTO_CONTINUACAO_CONVERSA = 'Continuação da conversa';

/**
 * O selo afirma o envio da câmara. A resposta da parte não tem status de entrega, e contá-la no
 * "mais fraco" deixaria o selo dizer algo sobre uma mensagem que a câmara não mandou.
 */
function bolhasEnviadas(conversa: ConversaWhatsappCertificado): BolhaWhatsappCertificado[] {
  return conversa.bolhas.filter(bolha => bolha.direcao === 'ENVIADA');
}
interface FatiaConversaWhatsappProps {
  conversa: ConversaWhatsappCertificado;
  bolha: BolhaWhatsappCertificado;
  primeira: boolean;
  ultima: boolean;
  /** A bolha abre uma página no meio da conversa: reabre a moldura com o rótulo de continuação. */
  continuacao: boolean;
  /** Primeira bolha do dia: o separador de data do WhatsApp. */
  mostrarData: boolean;
}

/**
 * Uma bolha da conversa, com a moldura fatiada como a da réplica de e-mail: o cabeçalho abre na
 * primeira fatia, a moldura fecha na última e as do meio só têm as bordas laterais — assim a
 * conversa continua um quadro só mesmo quando a quebra de página cai entre duas mensagens.
 *
 * O ícone de entrega é o da bolha, não o do grupo: cada bolha tem um destinatário só, então o
 * status que ela afirma é exatamente o daquela pessoa naquela mensagem.
 */
export function FatiaConversaWhatsapp(t0) {
  const $ = _c(47);
  const {
    conversa,
    bolha,
    primeira,
    ultima,
    continuacao,
    mostrarData
  } = t0;
  const abre = primeira || continuacao;
  const totalMensagens = conversa.bolhas.length;
  const recebida = bolha.direcao === "RECEBIDA";
  let t1;
  let t2;
  let t3;
  if ($[0] !== abre || $[1] !== conversa || $[2] !== primeira || $[3] !== totalMensagens || $[4] !== ultima) {
    const enviadas = bolhasEnviadas(conversa);
    t3 = `px-[37px] ${ultima ? "pb-[26px]" : ""}`;
    t1 = `w-[460px] overflow-hidden border-x border-solid border-neutral-200 ${abre ? "rounded-t-[10px] border-t" : ""} ${ultima ? "rounded-b-[10px] border-b" : ""}`;
    t2 = primeira ? <div className="flex items-center justify-between border-b border-solid border-neutral-200 bg-neutral-50 px-4 py-3"><div className="flex min-w-0 flex-col gap-0.5"><span className="text-[13px] font-semibold text-neutral-800">{conversa.nome}</span><span className="text-[11px] text-neutral-500">{conversa.contato ? `${conversa.contato} · ` : ""}{totalMensagens} {totalMensagens === 1 ? "mensagem" : "mensagens"}</span></div>{enviadas.length > 0 ? <BadgeEnvio status={statusEntregaMaisFraco(enviadas)} /> : null}</div> : null;
    $[0] = abre;
    $[1] = conversa;
    $[2] = primeira;
    $[3] = totalMensagens;
    $[4] = ultima;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== continuacao) {
    t4 = continuacao ? <RotuloContinuacao texto={TEXTO_CONTINUACAO_CONVERSA} /> : null;
    $[8] = continuacao;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `flex flex-col bg-[var(--bg-whatsapp-chat)] px-4 ${abre ? "pt-4" : "pt-1.5"} ${ultima ? "pb-4" : "pb-1.5"}`;
  let t6;
  if ($[10] !== bolha.dataLabel || $[11] !== mostrarData) {
    t6 = mostrarData ? <div className="mb-3 flex justify-center"><span className="rounded-lg bg-white/80 px-3 py-1 text-[11px] text-neutral-500">{bolha.dataLabel}</span></div> : null;
    $[10] = bolha.dataLabel;
    $[11] = mostrarData;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `flex ${recebida ? "justify-end" : "items-start"}`;
  const t8 = `flex max-w-[85%] flex-col rounded-lg px-3 py-2 shadow-sm ${recebida ? "wa-bubble-out" : "bg-white"}`;
  let t9;
  if ($[13] !== bolha.corpo) {
    t9 = convertWhatsAppTextToHtml(bolha.corpo);
    $[13] = bolha.corpo;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <span className="text-[12.5px] leading-[1.6] text-neutral-900" dangerouslySetInnerHTML={{
      __html: t9
    }} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== bolha.ressalva) {
    t11 = bolha.ressalva ? <span className="pt-0.5 text-[10.5px] text-neutral-500 italic">({bolha.ressalva})</span> : null;
    $[17] = bolha.ressalva;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== bolha.horaLabel) {
    t12 = <span className="text-[11px] text-neutral-500">{bolha.horaLabel}</span>;
    $[19] = bolha.horaLabel;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== bolha.statusEntrega || $[22] !== recebida) {
    t13 = recebida ? null : <OutboundStatusIcon status={bolha.statusEntrega} onLight={true} size={14} />;
    $[21] = bolha.statusEntrega;
    $[22] = recebida;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <div className="flex items-end justify-end gap-1 pt-1">{t12}{t13}</div>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t14 || $[30] !== t8) {
    t15 = <div className={t8}>{t10}{t11}{t14}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t14;
    $[30] = t8;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15 || $[33] !== t7) {
    t16 = <div className={t7}>{t15}</div>;
    $[32] = t15;
    $[33] = t7;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16 || $[36] !== t5 || $[37] !== t6) {
    t17 = <div className={t5}>{t6}{t16}</div>;
    $[35] = t16;
    $[36] = t5;
    $[37] = t6;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t1 || $[40] !== t17 || $[41] !== t2 || $[42] !== t4) {
    t18 = <div className={t1}>{t2}{t4}{t17}</div>;
    $[39] = t1;
    $[40] = t17;
    $[41] = t2;
    $[42] = t4;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18 || $[45] !== t3) {
    t19 = <div className={t3}>{t18}</div>;
    $[44] = t18;
    $[45] = t3;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
}
interface EmailDestinatariosProps {
  mensagem: MensagemEmailCertificado;
}
export function EmailDestinatarios(t0) {
  const $ = _c(13);
  const {
    mensagem
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-brand-600 mb-2 flex items-center gap-[10px]"><FeatherMail className="h-[15px] w-[15px]" /><span className="text-[12px] font-bold tracking-[0.6px]">E-mail</span></div>;
    t2 = <div className="mb-4 h-px bg-neutral-900 opacity-85" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <br />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== mensagem.assunto || $[5] !== mensagem.dataLabel || $[6] !== mensagem.de) {
    t5 = <div className="mb-3 text-[12.5px] leading-[1.8] font-bold text-neutral-700">De: {mensagem.de}{t3}Assunto: {mensagem.assunto}{t4}Data: {mensagem.dataLabel}</div>;
    $[4] = mensagem.assunto;
    $[5] = mensagem.dataLabel;
    $[6] = mensagem.de;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== mensagem.destinatarios) {
    t6 = <TabelaDestinatariosMensagem destinatarios={mensagem.destinatarios} contatoTitulo="E-mail" />;
    $[8] = mensagem.destinatarios;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="px-[37px]">{t1}{t2}{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
const TEXTO_CONTINUACAO_EMAIL = 'Continuação da cópia do e-mail';
function RotuloContinuacao(t0) {
  const $ = _c(5);
  const {
    texto
  } = t0;
  let t1;
  if ($[0] !== texto) {
    t1 = <span className="text-[9.5px] font-semibold tracking-[1.6px] whitespace-nowrap text-neutral-400 uppercase">{texto}</span>;
    $[0] = texto;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-px flex-1 bg-neutral-100" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="flex items-center gap-2.5 px-4 py-2">{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
interface ReplicaEmailFatiaProps {
  mensagem: MensagemEmailCertificado;
  /** Um nó de topo da cópia do e-mail — ver `fatiarConteudoEmail`. */
  conteudoHtml: string;
  primeira: boolean;
  ultima: boolean;
  /** A fatia abre uma página no meio da réplica: repete o rótulo de continuação. */
  continuacao: boolean;
}

/**
 * Uma fatia paginável da cópia do e-mail.
 *
 * A réplica inteira era UM bloco de paginação, mais alto que a folha A4 — e o mecanismo empurra
 * bloco atômico inteiro, então o excedente era cortado pelo `overflow-hidden` da página e coberto
 * pelo rodapé. O conteúdo cortado é exatamente a prova que a seção existe para exibir.
 *
 * A moldura abre na primeira fatia e fecha na última (mesmo recurso do texto oficial da sentença):
 * as do meio só têm as bordas laterais, então as fatias adjacentes formam um quadro contínuo e a
 * quebra de página não deixa a moldura "fechada" no meio do e-mail.
 */
export function ReplicaEmailFatia(t0) {
  const $ = _c(38);
  const {
    mensagem,
    conteudoHtml,
    primeira,
    ultima,
    continuacao
  } = t0;
  let t1;
  if ($[0] !== mensagem.destinatarios) {
    t1 = mensagem.destinatarios.map(_temp2).join(", ");
    $[0] = mensagem.destinatarios;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const emails = t1;
  const abre = primeira || continuacao;
  const t2 = `px-[37px] ${ultima ? "pb-[26px]" : ""}`;
  const t3 = `w-[540px] overflow-hidden border-x border-solid border-neutral-200 ${abre ? "rounded-t-[10px] border-t" : ""} ${ultima ? "rounded-b-[10px] border-b" : ""}`;
  let t4;
  if ($[2] !== emails || $[3] !== mensagem.assunto || $[4] !== mensagem.dataLabel || $[5] !== mensagem.de || $[6] !== mensagem.destinatarios || $[7] !== primeira) {
    t4 = primeira ? <div className="flex flex-col gap-1 border-b border-solid border-neutral-200 bg-neutral-50 px-4 py-3"><div className="flex items-center justify-between gap-2"><span className="text-[12.5px] font-semibold text-neutral-800">{mensagem.assunto}</span><BadgeEnvio status={statusEntregaMaisFraco(mensagem.destinatarios)} /></div><div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-neutral-500"><span>De: {mensagem.de}</span><span className="min-w-0 break-all">Para: {emails}</span><span>{mensagem.dataLabel}</span></div></div> : null;
    $[2] = emails;
    $[3] = mensagem.assunto;
    $[4] = mensagem.dataLabel;
    $[5] = mensagem.de;
    $[6] = mensagem.destinatarios;
    $[7] = primeira;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== continuacao) {
    t5 = continuacao ? <RotuloContinuacao texto={TEXTO_CONTINUACAO_EMAIL} /> : null;
    $[9] = continuacao;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `bg-neutral-50 px-6 ${abre ? "pt-4" : ""} ${ultima ? "pb-4" : ""}`;
  const t7 = `mx-auto w-full overflow-hidden border-x border-solid border-neutral-200 bg-white shadow-sm ${abre ? "rounded-t-[8px] border-t" : ""} ${ultima ? "rounded-b-[8px] border-b" : ""}`;
  let t8;
  if ($[11] !== primeira) {
    t8 = primeira ? <div className="bg-brand-600 flex items-center justify-center py-3"><LogoArbitralis variant="branco" className="[&_img]:h-6 [&_img]:w-auto" /></div> : null;
    $[11] = primeira;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = `[&_a]:text-brand-600 px-8 text-[12px] leading-[1.5] text-neutral-700 [&_a]:break-all [&_p]:mb-2 ${abre ? "pt-4" : ""} ${ultima ? "pb-4" : ""}`;
  let t10;
  if ($[13] !== conteudoHtml || $[14] !== t9) {
    t10 = <SanitizedHtml html={conteudoHtml} perfil="restrito" className={t9} />;
    $[13] = conteudoHtml;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== mensagem.rodapeLinhas || $[17] !== ultima) {
    t11 = ultima ? <div className="border-t border-solid border-neutral-200 bg-neutral-50 px-5 py-3 text-[8.5px] leading-[1.8] text-neutral-400">{mensagem.rodapeLinhas.map(_temp3)}</div> : null;
    $[16] = mensagem.rodapeLinhas;
    $[17] = ultima;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t7 || $[22] !== t8) {
    t12 = <div className={t7}>{t8}{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t7;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t6) {
    t13 = <div className={t6}>{t12}</div>;
    $[24] = t12;
    $[25] = t6;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== ultima) {
    t14 = ultima ? <div className="flex items-center gap-2 border-t border-solid border-neutral-100 bg-neutral-50 px-4 py-2"><FeatherInfo className="h-3.5 w-3.5 text-neutral-400" /><span className="text-[10.5px] text-neutral-500">O conteúdo acima reproduz o e-mail original enviado a todos os destinatários listados.</span></div> : null;
    $[27] = ultima;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14 || $[31] !== t3 || $[32] !== t4 || $[33] !== t5) {
    t15 = <div className={t3}>{t4}{t5}{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t2) {
    t16 = <div className={t2}>{t15}</div>;
    $[35] = t15;
    $[36] = t2;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
function _temp3(linha) {
  return <div key={linha}>{linha}</div>;
}
function _temp2(destinatario) {
  return destinatario.contato;
}